import {NO_TIME_LIMIT_TEXT} from "./consts";

const SuccessHTTPStatusRange = {
  MIN: 200,
  MAX: 299,
};

export const fetchData = async (url) => {
  const result = await fetch(url);

  if (result.status === 200) {
    return await result.json();
  } else {
    return {errorStatus: result.status};
  }
};

export const defaultPostData = async (data, url) => {
  const options = {
    method: `POST`,
    body: data,
  };

  const result = await fetch(url, options);
  // const result = await fetch(url);
  if (result.status === 200) {
    return await result.json();
  } else {
    return {errorStatus: result.status};
  }
};

export const postData = async (data, url) => {
  const options = {
    method: `POST`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: data,
  };

  const result = await fetch(url, options);
  // const result = await fetch(url);
  if (result.status === 200) {
    return await result.json();
  } else {
    return {errorStatus: result.status};
  }
};

const checkStatus = (response) => {
  if (response.status < SuccessHTTPStatusRange.MIN || response.status > SuccessHTTPStatusRange.MAX) {
    // console.error(`${response.status}: ${response.statusText}`);
    // return `error`;
    throw new Error(`${response.status}: ${response.statusText}`);
  }
};

const catchError = (err) => {
  throw err;
};

export const debounce = (cb, interval) => {
  let lastTimeout = null;

  return (...parameters) => {
    if (lastTimeout) {
      window.clearTimeout(lastTimeout);
    }
    lastTimeout = window.setTimeout(() => {
      cb(...parameters);
    }, interval);
  };
};

export const getDeclension = (number, titles) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
};

// Render

export const createElement = (template) => {
  const newElement = document.createElement(`div`);
  newElement.innerHTML = template;

  return newElement.firstChild;
};

export const renderElements = (parent, elements, getTemplate) => {
  elements.forEach((card) => {
    const template = getTemplate(card);
    const element = createElement(template);
    parent.append(element);
  });
};

export const renderElement = (parent, template, isPrepend) => {
  const element = createElement(template);
  if (isPrepend) {
    parent.prepend(element);
  } else {
    parent.append(element);
  }

  return element;
};

export const fadeIn = (element, timeout, display) => {
  element.style.opacity = 0;
  element.style.display = display || "block";
  element.style.transition = `opacity ${timeout}ms`;
  setTimeout(() => {
    element.style.opacity = 1;
  }, 10);
};

export const fadeOut = (element, timeout) => {
  element.style.opacity = 1;
  element.style.transition = `opacity ${timeout}ms`;
  element.style.opacity = 0;

  setTimeout(() => {
    element.style.display = "none";
  }, timeout);
};

// Показываем модальное окно
export const openModal = (modal, display) => {
  fadeIn(modal, 200, display);
};

// Скрываем модальное окно
export const closeModal = (modal) => {
  fadeOut(modal, 200);
};

export const createEvent = (name) => {
  return new Event(name, {bubbles: true, cancelable: true});
};

export const getDaysText = (days) => {
  if (days === NO_TIME_LIMIT_TEXT) {
    return days;
  }

  if (days === 0) {
    return `сегодня`;
  }

  if (days === 1) {
    return `завтра`;
  }

  return `${days < 0 ? -days : days} ${getDeclension(days < 0 ? -days : days, [`день`, `дня`, `дней`])}`;
};

const addDigitToMinutes = (minutes) => {
  return minutes.toString(10)
    .padStart(2, `0`);
};

export const formattingDate = (
  date,
  {isDefaultFormat = false, isISO = false, showTime = false, showWeekDay = false, separator = `, `},
) => {
  if (isDefaultFormat) {
    return date.toLocaleDateString("ru-ru", {
      year: "numeric",
      day: "numeric",
      month: "numeric",
      hour: showTime ? "numeric" : undefined,
      minute: showTime ? "2-digit" : undefined,
    });
  }

  if (isISO) {
    return date.toISOString();
  }

  const today = new Date();

  if (
    `${date.getUTCFullYear()}:${date.getUTCMonth()}:${date.getUTCDate()}` ===
    `${today.getUTCFullYear()}:${today.getUTCMonth()}:${today.getUTCDate()}`
  ) {
    return `Сегодня${showTime ? `${separator}${date.getHours()}:${addDigitToMinutes(date.getMinutes())}` : ``}`;
  }

  if (
    today.getUTCDate() - date.getUTCDate() === 1 &&
    `${date.getUTCFullYear()}:${date.getUTCMonth()}` ===
    `${today.getUTCFullYear()}:${today.getUTCMonth()}`
  ) {
    return `Вчера${showTime ? `${separator}${date.getHours()}:${addDigitToMinutes(date.getMinutes())}` : ``}`;
  }

  return date.toLocaleDateString("ru-ru", {
    weekday: showWeekDay ? "short" : undefined,
    year:
      date.getUTCFullYear() !== today.getUTCFullYear() ? "numeric" : undefined,
    day: "numeric",
    month:
      date.getUTCFullYear() !== today.getUTCFullYear() ? "numeric" : "long",
    hour: showTime ? "numeric" : undefined,
    minute: showTime ? "2-digit" : undefined,
  });
};

export const getCurrentUser = () => {
  const nameElement = document.querySelector(`.js-current-user-name`);
  return {
    name: nameElement.dataset.name,
    img: document.querySelector(`.js-current-user-avatar`).src,
    fullName: nameElement.dataset.fullName,
    email: document.querySelector(`.js-current-user-email`).textContent.trim(),
  };
};
